import React from 'react';
import { Spinner } from 'bv-components';
import withLazyLoad from 'bv-lazy-load';

const embeddedLazyLoad = withLazyLoad(<Spinner />);

export const MiniGames = embeddedLazyLoad('miniGames');
export const MiniLaunch = embeddedLazyLoad('miniLaunch');
